export const webConfisyControlarConstants = {
  LIST_CONFISYS_CONTROLAR_REQUEST: 'LIST_CONFISYS_CONTROLAR_REQUEST',
  LIST_CONFISYS_CONTROLAR_SUCCESS: 'LIST_CONFISYS_CONTROLAR_SUCCESS',
  LIST_CONFISYS_CONTROLAR_FAILURE: 'LIST_CONFISYS_CONTROLAR_FAILURE'
};
